import { load } from 'cheerio';
import ISpecification from '@/interfaces/ISpecification';
import Provider from '@/enums/Provider';

export function extractProductSpecification(
  htmlSource: string,
  provider: Provider
): ISpecification {
  const $ = load(htmlSource);
  let suitableFor = '';
  let size = '';
  let requiredSpace = '';
  switch (provider) {
    case Provider.KBS:
      // Extract the specifications from the table
      $('table.table-striped tr').each((i, elem) => {
        const row = $(elem).find('td').first().text().trim();

        if (row.includes('Product Size')) {
          size = $(elem).find('td').last().text().trim();
        }

        if (row.includes('Required Space')) {
          requiredSpace = $(elem).find('td').last().text().trim();
        }

        if (row.includes('Suitable For')) {
          suitableFor = $(elem).find('td').last().text().trim();
        }
      });
      break;
    case Provider.IO: {
      const ioSize = $('.io_product_dimensions_left').next('p').text().trim();
      if (ioSize) {
        size = ioSize;
      } else {
        size = '';
      }

      // Get the text following the element with class "io_product_footprint_left" for the required space.
      const ioSpace = $('.io_product_footprint_left').next('p').text().trim();
      if (ioSpace) {
        requiredSpace = ioSpace;
      } else {
        requiredSpace = '';
      }

      // IO pages do not appear to include a "Suitable For" field so default it.
      suitableFor = '';
      break;
    }
    case Provider.ERS:
      $('ul.item-info-list li, .describe-list-content p').each((i, elem) => {
        const text = $(elem).text().trim();
        const [label, value] = text.split(':').map(s => s.trim());

        if (!label || !value) return;

        switch (label.toLowerCase()) {
          case 'actual size':
            size = value;
            break;
          case 'setup area':
            requiredSpace = value;
            break;
          case 'age group':
            suitableFor = value;
            break;
          // Add more cases as needed
        }
      });
      break;
    default:
      break;
  }
  return { suitableFor, size, requiredSpace }
}
